<template>
  <div class="bill">
    <div class="contentRight2">
      <!-- 账单明细界面 -->
      <div>
        <div class="rightHead">
          <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">核销记录</div>
        </div>
        <div class="billHead">
          <div class="row">
            <el-input v-model="value" class="input1" size placeholder="搜索优惠券号码"></el-input>
            <!-- 日期选择 -->
            <div class="block">
              <el-date-picker
                v-model="value2"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
          </div>
          <div class="row" style="margin-top:20px;">
            <el-button class="button1" @click="search" type="primary">搜索</el-button>
            <el-button class="button1" @click="clear">重置</el-button>
            <!-- <el-button class="button1" @click="excel">订单导出</el-button> -->
          </div>
        </div>
        <div class="content">
          <!-- 表格 -->
          <div>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column align="center" prop="userId" label="会员ID" width="180"></el-table-column>
              <el-table-column align="center" prop="userName" label="会员手机号" width="180"></el-table-column>
              <el-table-column align="center" prop="operateUserName" label="核销人"></el-table-column>
              <el-table-column align="center" prop="usedTime" label="核销日期"></el-table-column>
              <el-table-column align="center" prop="price" label="使用金额"></el-table-column>
            </el-table>
          </div>
          <!-- <div v-if="noData">暂无数据</div> -->
          <!-- 分页 -->
          <div v-if="totalNum" class="block" style="float:right;margin-top:10px;">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="1"
              :page-size="20"
              layout="total, prev, pager, next, jumper"
              :total="totalNum"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  printOrder,
  writeOffCashCouponList,
  writeOffListTotalNum
} from "../api";
import { getLodop } from "@/utils/LodopFuncs";
export default {
  data() {
    return {
      noData: false,
      // 日期选择
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      totalCount: "",
      totalCount2: "",
      totalCount3: "",
      value2: "", //日期
      value: "", //卷号码
      userList: "",
      shopInformation:'',
      tableData: [],
      totalNum: 0
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.writeOffCashCouponList(1);
  },
  methods: {
    //分页当前页
    handleCurrentChange(val) {
      if (!this.value2) {
        this.value2 = "";
      }
      this.writeOffCashCouponList(
        val,
        this.value,
        this.value2[0],
        this.value2[1]
      );
    },
    //搜索按钮
    search() {
      if (!this.value2) {
        this.value2 = "";
      }
      this.writeOffCashCouponList(
        1,
        this.value,
        this.value2[0],
        this.value2[1]
      );
    },
    clear() {
      (this.value = ""), (this.value2 = "");
    },
    writeOffCashCouponList(pageNo, cashCouponCode, startDate, endDate) {
      writeOffCashCouponList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageSize: 20,
        pageNo: pageNo,
        cashCouponCode: cashCouponCode,
        startDate: startDate,
        endDate: endDate
      }).then(res => {
        console.log(res.data, "核销");
        if (res.code == 1) {
          this.tableData = res.data;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else if (res.code == -1) {
          this.tableData = []
        } else {

        }
      });
      writeOffListTotalNum({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNo: pageNo,
        cashCouponCode: cashCouponCode,
        startDate: startDate,
        endDate: endDate
      }).then(res => {
        console.log(res.data, "核销记录数");
        if (res.code == 1) {
          this.totalNum = res.data.totalNum;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    }
  }
};
</script>

<style scoped>
.billHead {
  box-sizing: border-box;
  width: 100%;
  padding: 30px 0px 20px 30px;
  background: #f8f8f8;
  padding-top: 80px;
}
.billHead2 {
  box-sizing: border-box;
  width: 100%;
  background: #f8f8f8;
  padding: 13px 0 0 25px;
  position: fixed;
  top: 49px;
  z-index: 100;
}
.input1 {
  width: 200px;
  margin-right: 20px;
}
.margin20 {
  margin-left: 20px;
}
.button1 {
  height: 30px;
  padding: 0 10px;
}
.content {
  padding: 20px 30px;
}
.button5 {
  width: 45px;
  height: 30px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
}
.button2 {
  width: 70px;
  height: 30px;
  padding: 0;
  position: absolute;
  right: 100px;
  bottom: 20px;
}
.button6 {
  width: 70px;
  height: 30px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.content img {
  height: 30px;
  width: 30px;
}
.content .time {
  font-size: 12px;
  margin-bottom: 20px;
}
.content .red {
  color: red;
}
#page2 .content {
  box-sizing: border-box;
  padding: 30px;
  padding-top: 120px;
}
#page2 .state,
#page3 .state {
  box-sizing: border-box;
  background: #f8f8f8;
  height: 185px;
  width: 275px;
  padding: 10px;
}
#page2 .state img,
#page3 .state img {
  height: 47px;
  width: 47px;
  margin-top: 10px;
}
#page2 .title,
#page3 .title {
  width: 100%;
  font-size: 12px;
  font-weight: 600;
}
#page2 .text1,
#page3 .text1 {
  color: #ff6e6e;
  font-size: 17px;
  font-weight: 500;
  margin-top: 10px;
}
#page2 .text2,
#page3 .text2 {
  margin-top: 10px;
  font-size: 12px;
}
.primary {
  position: relative;
  width: calc(100% - 295px);
  box-sizing: border-box;
  background: #f8f8f8;
  margin-left: 20px;
  height: 185px;
  padding: 10px 25px;
}
.primaryContent {
  margin-top: 30px;
  font-size: 12px;
  color: #767676;
}
.primaryContent .block1 div:not(:first-child) {
  margin-top: 10px;
}
.primaryContent .block2 div:not(:first-child) {
  margin-top: 10px;
}
.primaryContent .block2 {
  margin-left: 85px;
}
#page3 .content {
  padding: 30px;
  padding-top: 120px;
}
#page3 .top {
  box-sizing: border-box;
  width: 100%;
  height: 125px;
  padding: 12px 25px;
  background: #f8f8f8;
}
.blue {
  color: #2f9ceb;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/page/ZWHXJL.vue